import { Link } from 'react-router-dom';
import logoLuminjo from '@/assets/logo-luminjo-blanc.png';
import { useSuperAdmin } from '@/hooks/useSuperAdmin';
import { ShieldIcon } from '@/config/icons';

export function Footer() {
  const currentYear = new Date().getFullYear();
  const { isSuperAdmin } = useSuperAdmin();

  return (
    <footer className="border-t border-sidebar-border bg-sidebar py-4 px-6 pl-[calc(16rem+1.5rem)]">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-sidebar-foreground">
        <div className="flex items-center gap-1.5">
          <span>©</span>
          <a 
            href="https://fr.luminjo.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:opacity-80 transition-opacity"
          >
            <img src={logoLuminjo} alt="Luminjo" className="h-5 w-auto" />
          </a>
          <span>2026 par le groupe </span>
          <a 
            href="https://www.awelty.fr" 
            target="_blank" 
            rel="noopener noreferrer"
            className="underline font-medium hover:text-sidebar-accent-foreground transition-colors"
          >Awelty</a>
          <span>. Tous droits réservés.</span>
        </div>
        <div className="flex items-center gap-4">
          <a 
            href="https://fr.luminjo.com/pages/aide/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-sidebar-accent-foreground transition-colors"
          >
            Aide
          </a>
          <a 
            href="https://fr.luminjo.com/pages/cgu.html" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-sidebar-accent-foreground transition-colors"
          >
            CGU
          </a>
          <a 
            href="https://fr.luminjo.com/pages/cgv.html" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-sidebar-accent-foreground transition-colors"
          >
            CGV
          </a>
          <a 
            href="https://fr.luminjo.com/pages/a-propos.html" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-sidebar-accent-foreground transition-colors"
          >
            Mentions légales
          </a>
          <a 
            href="mailto:contact@luminjo.com" 
            className="hover:text-sidebar-accent-foreground transition-colors"
          >
            Contact
          </a>
          {isSuperAdmin && (
            <Link 
              to="/admin" 
              className="flex items-center gap-1 text-destructive hover:text-destructive/80 transition-colors"
            >
              <ShieldIcon className="h-3.5 w-3.5" />
              Admin
            </Link>
          )}
        </div>
      </div>
    </footer>
  );
}
